// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonPage from 'app/common/templates/CommonPage';
import { HelpInfo } from 'app/common/components-next/help';

import SendUsMessage from './SendUsMessage';

/**
 *  Страница раздела помощи
 */

type Props = {
  router: {
    push: (string) => void,
  },
  params: {
    section: string,
    messageId: string,
  },
}

const HelpPage = ({
  router: { push },
  params: { section, messageId },
}: Props) => {
  const { t } = useTranslation('help');

  return (
    <CommonPage header={t('header', 'Помощь')}>
      <HelpInfo />
      <SendUsMessage
        push={push}
        section={section}
        messageId={messageId}
      />
    </CommonPage>
  );
};

export default HelpPage;
